import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { I18nService } from '@gruposaltaedu/liv-i18n/core';

import { environment } from '../../../environments/environment';
import { appLanguageToPortfolioApiLocale } from '../app-locale';

function normalizeBase(url: string): string {
  return url.replace(/\/$/, '');
}

function isPortfolioApiRequest(
  reqUrl: string,
  portfolioApiBase: string
): boolean {
  const base = normalizeBase(portfolioApiBase);
  const path = reqUrl.split('?')[0];
  return path === base || path.startsWith(`${base}/`);
}

export const portfolioLocaleQueryInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  const i18n = inject(I18nService);

  if (!isPortfolioApiRequest(req.url, environment.apiPortfolio)) {
    return next(req);
  }

  if (req.params.has('locale')) {
    return next(req);
  }

  const locale = appLanguageToPortfolioApiLocale(i18n.currentLanguage());
  return next(
    req.clone({
      params: req.params.set('locale', locale)
    })
  );
};
